/* eslint-disable space-in-parens */

import Vue from 'vue'
export const MobileDetect = require('mobile-detect')
export const mobileDetect = new MobileDetect(window.navigator.userAgent)
export const md = mobileDetect
export default md

Vue.prototype.$mobileDetect = md
Vue.prototype.$md = md
Vue.prototype.$mobile = md.mobile()
